import { render, staticRenderFns } from "./UserTabRemote.vue?vue&type=template&id=035296f0&scoped=true&"
import script from "./UserTabRemote.vue?vue&type=script&lang=js&"
export * from "./UserTabRemote.vue?vue&type=script&lang=js&"
import style0 from "./UserTabRemote.vue?vue&type=style&index=0&id=035296f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035296f0",
  null
  
)

export default component.exports